export enum SessionMessage {
    Authenticate = "urn:x-cast:com.247e.music.authenticate"
}
